import {ContractsDao} from '../../dao';
import {ErrorModel} from '../../models';
import { getAllContractsSchema } from './_schema/getAllContracts.schema';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_ALL_CONTRACTS';

export async function getAllContracts(
    token: string,
    params: string,
    page: number
) {
    try {
        const result = await ContractsDao.getAllContracts(token, params, page);

        const parsedResult = getAllContractsSchema.parse(result.results);

        const metadata = {
            count: result.count,
            next: result.next,
            previous: result.previous
        };

        return {
            metadata,
            data: parsedResult
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation des contrats',
            error: error
        });
    }
}
